<script lang="ts">
  import { onMount } from "svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import Icon from "../../components/Icon.svelte";
  import {
    initUserDetail,
    selfUser,
    describeRole,
    save,
    changePassword,
    changePasswordDto,
    passwordChangedMessage,
  } from "./profile.store";

  $: fullName =
    $selfUser != null ? $selfUser.firstName + " " + $selfUser.lastName : "";

  $: roleDescription =
    $selfUser != null ? describeRole($selfUser.portalRoleCode) : "";

  $: canChangePassword =
    $changePasswordDto != null &&
    $changePasswordDto.oldPassword != "" &&
    $changePasswordDto.newPassword1 != "" &&
    $changePasswordDto.newPassword2 != "";

  async function onSubmit() {
    await save();
  }

  async function doChangePassword() {
    await changePassword();
  }

  onMount(() => initUserDetail());
</script>

<MainLayout>
  {#if $selfUser}
    <div class="user-profile-parent">
      <article class="panel is-primary profile">
        <p class="panel-heading has-text-centered valign-center-box">
          <Icon name="perm_identity" customIconStyle="color: white;" />
          <span style="padding-left: 0.8rem;">Profilo</span>
        </p>

        <div class="user-info-banner">
          <div class="valign-center-box">
            <img src="/img/profile-image.png" alt="Immagine profilo" />

            <div>
              <div class="has-text-weight-bold">
                {fullName}
              </div>

              <div class="is-italic">
                {roleDescription}
              </div>
            </div>
          </div>

          <hr />
        </div>

        <div class="columns">
          <div class="column">
            <FormLayout
              on:submit={onSubmit}
              submitButtonText="Aggiorna profilo"
              cancelEnabled={false}
            >
              <FormField>
                <Input
                  placeholder="e-mail"
                  disabled={true}
                  bind:value={$selfUser.email}
                  name="e-mail"
                />
              </FormField>

              <FormField>
                <Input
                  placeholder="nome"
                  disabled={false}
                  bind:value={$selfUser.firstName}
                  name="Nome"
                />
              </FormField>

              <FormField>
                <Input
                  placeholder="last name"
                  disabled={false}
                  bind:value={$selfUser.lastName}
                  name="Cognome"
                />
              </FormField>
            </FormLayout>
          </div>

          <div class="column">
            <FormLayout
              on:submit={doChangePassword}
              canSubmit={canChangePassword}
              submitButtonText="Modifica password"
              cancelEnabled={false}
            >
              <FormField>
                <Input
                  placeholder="password attuale"
                  disabled={false}
                  bind:value={$changePasswordDto.oldPassword}
                  type="password"
                  name="Password attuale"
                />
              </FormField>

              <FormField>
                <Input
                  placeholder="nuova password"
                  disabled={false}
                  bind:value={$changePasswordDto.newPassword1}
                  type="password"
                  name="Nuova password"
                />
              </FormField>

              <FormField>
                <Input
                  placeholder="ripeti nuova password"
                  disabled={false}
                  bind:value={$changePasswordDto.newPassword2}
                  type="password"
                  name="Ripeti nuova password"
                />
              </FormField>

              {#if $passwordChangedMessage != ''}
                <article class="message is-warning">
                  <div class="message-body">
                    {$passwordChangedMessage}
                  </div>
                </article>
              {/if}
            </FormLayout>
          </div>
        </div>
      </article>
    </div>
  {/if}
</MainLayout>

<style>
  .user-profile-parent {
    padding-top: 2rem;
    max-width: 70%;
    margin: auto;
  }
</style>
